<!--
 * @Author: Merlin
 * @Date: 2023-12-01 09:52:15
 * @LastEditors: Merlin
 * @LastEditTime: 2023-12-14 17:13:00
 * @Description: 
-->
<!-- ▼查看此组件示例：http://localhost:3000/casino/crashGame -->

<template>
    <button class="favorite-btn"
        :class="{
            'be-wide': beWide,
            'liked': isLiked,
        }"
    >
        <span class="content" @click="toLike">
            <q-tooltip anchor="top middle" self="bottom middle">
                {{$t('favorite.tips')}}
            </q-tooltip>
            <span class="btn-name" >
                {{$t('favorite.btnName')}}
            </span>
            <IconSvgUse class="empty" width="20" height="20" use="icon-hearth-empty" />
            <IconSvgUse class="full" width="20" height="20" use="icon-hearth-full" />
            <em class="">
                {{'14.66k'}}
            </em>
        </span>
    </button>
</template>

<script setup>
const props = defineProps({
    beWide: {
        type: Boolean,
    },
    gameID: {
        type: String, // 后期应按游戏 id 的值显示当前红心是否点亮
    },
});

const isLiked = ref(false);
const toLike = () => {
    isLiked.value = !isLiked.value;
}

</script>

<style scoped lang="scss">
.favorite-btn{
    align-items: center;
    background-color: #111923e6;
    border: 1px solid #161f2c;
    border-radius: 12px;
    display: flex;
    padding: 6px;
    cursor: default;
    &[class~=liked]{
        .empty{
            display: none;
        }
        .full{
            display: unset;
        }
    }
    &[class~=be-wide]{
        width: 100%;
        .btn-name{
            display: inline;
        }
    }
}


.content{
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    cursor: pointer;
    background-color: #202a39;
    border-radius: 8px;
    padding: 5px;
    color: #93acd3;
    align-items: center;
    width: 100%;
    .full{
        display: none;
        color: #ed1d49;
    }
    .btn-name{
        display: none;
        margin: 0 4px 0;
    }
    &:hover{
        background-color: #263041;
    }
    em{
        line-height: 16px;
        font-size: 12px;
        font-weight: 600;
        font-style: normal;
        margin: 0 4px 0;
    }
}

</style>